import { render } from "./SentenceSearch.vue?vue&type=template&id=7d2dcb3e&scoped=true"
import script from "./SentenceSearch.vue?vue&type=script&lang=js"
export * from "./SentenceSearch.vue?vue&type=script&lang=js"

import "./SentenceSearch.vue?vue&type=style&index=0&id=7d2dcb3e&lang=css"
import "./SentenceSearch.vue?vue&type=style&index=1&id=7d2dcb3e&scoped=true&lang=css"

import exportComponent from "D:\\MY PROJECTS\\VUE_3\\EXCEL_LIBRARY\\excel-library-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d2dcb3e"]])

export default __exports__